import React, { useEffect, useState } from 'react';
import { get, isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import { userSelector } from 'store/user/selectors';
import { injectIntl, IntlShape } from 'react-intl';
import { getListDossiers, getTokenApi } from 'store/user/apis';
import { REQUESTS_STATUSES } from 'constants/amcStatuses';
import { getContractsAMC } from 'store/contract/selectors';
import { StyledtBlocWrapper } from 'containers/AmcDetailsPage/FollowUpMyRequestsTab/styles';
import {
  StyledTabs,
  StyledTab,
} from 'containers/AmcDetailsPage/FollowUpMyRequestsTab/MyRequests/styles';
import Requests from 'components/Requests';
import { translate } from 'helpers/intl';
import moment from 'moment';
import _ from 'lodash';
import { Box, CircularProgress } from '@material-ui/core';
import {
  StyledCard,
  StyledGrid,
} from 'containers/AUTODashboard/Body/LastSinister/styles';
import ItemEmptyState from 'components/ItemEmptyState';
import messages from './messages';

function a11yProps(index: number) {
  return {
    id: `my-contracts-tab-${index}`,
    'aria-controls': `my-contracts-tabpanel-${index}`,
  };
}

export interface tabItemProps {
  label: string;
}
export interface listDossierType {
  DateConsultation: string;
  DateCreation: string;
  TypeDossier: string;
  Frais: string;
  Statut: number;
  Reference: string;
  NomPrenomAdherent?: string;
  MotifRejet?: string;
  NumDeclaration?: string;
  date: string;
}

export interface DossiersType {
  [key: string]: listDossierType[];
}

const MyRequests = ({
  ...props
}: {
  intl: IntlShape;
  selectedOrganisme?: any;
}) => {
  const [expandeds, setExpanded] = useState<boolean | String>(false);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [listDossier, setListDossiers] = useState<DossiersType>({});
  const [unfiltredListDossier, setUnfiltredListDossiers] = useState<
    listDossierType[]
  >([]);
  const [value, setValue] = React.useState(0);
  const handleChange = (index: String, claimNumber: String) => (
    event: React.ChangeEvent<{}>,
    isExpanded: boolean,
  ) => {
    /* istanbul ignore next */
    setExpanded(isExpanded ? index : false);
  };

  const handleChangeTab = (event: React.ChangeEvent<{}>, newValue: number) => {
    // eslint-disable-next-line
    setValue(newValue);
  };
  const getUser = useSelector(userSelector);
  const getContracts = useSelector(getContractsAMC);

  const token = localStorage.getItem('token');
  /* istanbul ignore next */
  useEffect(() => {
    setLoading(true);
    getTokenApi({
      identifiant: props.selectedOrganisme?.id,
      token: token ? token : '',
      username: props.selectedOrganisme?.NUM_POLICE,
    })
      .then((result) => {
        const res = get(result, 'data', {});
        if (!isEmpty(res)) {
          const payload = {
            NumPolice: res?.numeroPolice?.replace('/', '_'),
            NumIdentification: res?.login,
            token: res?.access_token,
            sessionsId: res?.session_id,
          };
          getListDossiers(payload)
            .then((result) => {
              const res = get(result, 'data', {});
              setUnfiltredListDossiers(res);
              setLoading(false);
            })
            .catch(() => setLoading(false));
        }
      })
      .catch(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getUser, token, getContracts, props.selectedOrganisme]);

  const filterData = (data: listDossierType[]) => {
    return _.groupBy(
      data.map(
        /* istanbul ignore next */ (e: listDossierType) => ({
          date: e.DateConsultation.split('/')[2],
          DateConsultation: e.DateConsultation,
          Statut: e.Statut,
          Reference: e.Reference,
          TypeDossier: e.TypeDossier,
          DateCreation: moment(e.DateCreation).format('DD/MM/YYYY'),
          NomPrenomAdherent: e.NomPrenomAdherent,
          Frais: e.Frais,
          MotifRejet: e.MotifRejet,
          NumDeclaration: e.NumDeclaration,
        }),
      ),
      'date',
    ) as DossiersType;
  };

  useEffect(() => {
    const dossiers = filterData(unfiltredListDossier);

    setListDossiers(dossiers);
  }, [unfiltredListDossier]);

  const tabItems = [
    {
      label: translate({ ...messages.allRequests }, props),
    },
    {
      label: translate({ ...messages.createdRequests }, props),
    },
    {
      label: translate({ ...messages.validatedRequests }, props),
    },
    {
      label: translate({ ...messages.rejectedRequests }, props),
    },
  ];

  /* istanbul ignore next */
  const getListRquests = () => {
    switch (value) {
      case 1:
        return filterData(
          unfiltredListDossier.filter(
            (item) => item.Statut === REQUESTS_STATUSES.CREATED,
          ),
        );
      case 2:
        return filterData(
          unfiltredListDossier.filter(
            (item) => item.Statut === REQUESTS_STATUSES.VALIDATED,
          ),
        );
      case 3:
        return filterData(
          unfiltredListDossier.filter(
            (item) => item.Statut === REQUESTS_STATUSES.REJECTED,
          ),
        );
      default:
        return listDossier;
    }
  };

  return (
    <StyledtBlocWrapper height="auto">
      <StyledTabs
        value={value}
        onChange={handleChangeTab}
        aria-label="my contracts tabs"
        style={{ marginBottom: '20px' }}
      >
        {tabItems.map((tab: tabItemProps, index) => (
          <StyledTab
            key={index}
            label={tab.label}
            {...a11yProps(index)}
            disableRipple
          />
        ))}
      </StyledTabs>
      {isLoading ? (
        <Box
          style={{
            textAlign: 'center',
            marginTop: 42,
            marginBottom: 42,
          }}
        >
          <CircularProgress color="inherit" size={20} />
        </Box>
      ) : Object.keys(getListRquests()).length === 0 ? (
        <StyledCard>
          <StyledGrid
            container
            textAlign="center"
            alignItems="center"
            justify="center"
            marginBottom="17px"
          >
            <ItemEmptyState
              label={translate({ ...messages.emptyState }, props)}
            />
          </StyledGrid>
        </StyledCard>
      ) : (
        <Requests
          listIndex={0}
          isLoading={isLoading}
          requests={getListRquests()}
          expanded={expandeds}
          handleChange={
            /* istanbul ignore next */ (index: String, claimNumber: String) =>
              handleChange(index, claimNumber)
          }
        />
      )}
    </StyledtBlocWrapper>
  );
};
export default injectIntl(MyRequests);
